/* eslint-disable */
//tslint:disable

export interface IConditionSchema {
  /** Поле, значение которого надо сравнивать с value для определения следующего шага **/
  answerField: EAnswerField;
  /** Способ сравнения ответа на текущий вопрос с value **/
  compareType: ECompareType;
  /** Сравниваемое значение. Для compare_type!=in_list всегда сравнивается первое значение массива. **/
  value: string[];
}

export enum EAnswerField {
  /** Поле для ответа отсутствует **/
  Absent = 'absent',
  /** Укажите адрес **/
  Address = 'address',
  /** Какая техника есть в квартире? **/
  Appliances = 'appliances',
  /** Оцените стоимость {техники и мебели} **/
  AppliancesAndFurnitureCost = 'appliancesAndFurnitureCost',
  /** Укажите общую площадь **/
  Area = 'area',
  /** Площадь от **/
  AreaFrom = 'areaFrom',
  /** Площадь до **/
  AreaTo = 'areaTo',
  /** Укажите высоту потолков **/
  CeilingHeight = 'ceilingHeight',
  /** Можно с детьми? **/
  ChildrenAllowed = 'childrenAllowed',
  /** Комфорт **/
  Comfort = 'comfort',
  /** Есть, что добавить? / Опишите вашу ситуацию **/
  Comment = 'comment',
  /** Рассматриваете ли вы возможность начать сотрудничество с риэлтором? **/
  CooperationStatus = 'cooperationStatus',
  /** Как срочно хотите совершить сделку? **/
  DealPeriod = 'dealPeriod',
  /** Как срочно хотите совершить сделку? (признак эксперимента) **/
  DealPeriodExperimental = 'dealPeriodExperimental',
  /** Чем риелтор может вам помочь? так-то это dealType, только странный **/
  DealTypeEx = 'dealTypeEx',
  /** Введите адрес электронной почты **/
  Email = 'email',
  /** Новостройка или вторичка? **/
  FirstOrSecond = 'firstOrSecond',
  /** На каком этаже расположена квартира? **/
  Floor = 'floor',
  /** Сколько этажей в доме? **/
  FloorMax = 'floorMax',
  /** Форма с выбранными риэлторами отправлена **/
  FormSentWithRealtors = 'formSentWithRealtors',
  /** Как вас зовут? **/
  FullName = 'fullName',
  /** Похоже, вы уже оценивали эту квартиру **/
  HasEstimation = 'hasEstimation',
  /** Системный AnswerField под наличие объявлений аренды **/
  HasRentOfferData = 'hasRentOfferData',
  /** Системный AnswerField под наличие объявлений продажи **/
  HasSaleOfferData = 'hasSaleOfferData',
  /** Скрытый шаг для отправки формы **/
  HiddenSubmitter = 'hiddenSubmitter',
  /** Укажите тип дома **/
  HouseMaterialType = 'houseMaterialType',
  /** Включая коммунальные платежи **/
  IncludeCommunal = 'includeCommunal',
  /** Включая эксплуатационные налоги **/
  IncludeOperationalTaxes = 'includeOperationalTaxes',
  /** Вопрос, где нужно выбрать инфраструктуру **/
  Infrastructure = 'infrastructure',
  /** Вы агент по недвижимости? **/
  IsAgent = 'isAgent',
  /** Доступнен ли выбор риэлторов? **/
  IsAvailableRealtorChoice = 'isAvailableRealtorChoice',
  /** Объект в залоге у банка? **/
  IsBankDeposit = 'isBankDeposit',
  /** Планируете брать кредит? **/
  IsCredit = 'isCredit',
  /** Вы уже разместили объявление? **/
  IsHasOffer = 'isHasOffer',
  /** Вы получили квартиру в наследство? **/
  IsInheritance = 'isInheritance',
  /** В числе собственников есть несовершеннолетние? **/
  IsMinorOwners = 'isMinorOwners',
  /** Уже накопили на первоначальный взнос? **/
  IsMortgageInitialPayment = 'isMortgageInitialPayment',
  /**  **/
  IsOfferDataCorrect = 'isOfferDataCorrect',
  /** Вы знаете параметры квартиры и дома? **/
  IsOfferParamsKnown = 'isOfferParamsKnown',
  /** Уже выбрали проект дома под строительство? **/
  IsProjectExists = 'isProjectExists',
  /** Вы готовы снизить цену, в случае необходимости? **/
  IsReadyToLower = 'isReadyToLower',
  /** В квартире такая планировка? **/
  Layout = 'layout',
  /** Будете заключать договор аренды? **/
  LeaseAgreement = 'leaseAgreement',
  /** Есть лоджия или балкон? **/
  LoggiaOrBalcony = 'loggiaOrBalcony',
  /** Уже есть одобрение ипотеки от банка? **/
  MortgageBankApprove = 'mortgageBankApprove',
  /** Рассматриваете вариант покупки участка и постройки {дома}? **/
  NeedLandForBuilding = 'needLandForBuilding',
  /** Хотите подобрать проект дома и рассчитать его примерную стоимость? **/
  NeedProject = 'needProject',
  /** Уточните тип недвижимости **/
  ObjectType = 'objectType',
  /** Выберите объявление **/
  Offer = 'offer',
  /** Какую недвижимость хотите продать? **/
  OfferType = 'offerType',
  /** Мы нашли объявления квартир с похожими параметрами. Вы хотите оценить квартиру из объявления? **/
  OffersFound = 'offersFound',
  /** В течение последних 10 лет в квартире производился капитальный ремонт? **/
  Overhaul = 'overhaul',
  /** Можно с животными? **/
  PetsAllowed = 'petsAllowed',
  /** Укажите номер мобильного телефона (с смс подтверждением) **/
  Phone = 'phone',
  /** Укажите номер мобильного телефона **/
  PhoneVerify = 'phoneVerify',
  /** Укажите предпочитаемую цену **/
  Price = 'price',
  /** Цена от **/
  PriceFrom = 'priceFrom',
  /** Цена до **/
  PriceTo = 'priceTo',
  /** Как планируете покупать квартиру? **/
  PurchaseMethod = 'purchaseMethod',
  /** Шаг с выбором риэлторов **/
  RealtorListing = 'realtorListing',
  /** Срок аренды **/
  RentType = 'rentType',
  /** Выберите текущий тип ремонта **/
  Repair = 'repair',
  /** Сколько лет ремонту? **/
  RepairAge = 'repairAge',
  /** Оцените стоимость ремонта. С учетом ремонта кухни, если он производился **/
  RepairCost = 'repairCost',
  /** Укажите количество комнат **/
  RoomCount = 'roomCount',
  /** Идентификатор подписки на оценку **/
  SubscriptionId = 'subscriptionId',
  /** Время до метро **/
  TimeToMetro = 'timeToMetro',
  /** Почему вас заинтересовала оценка? **/
  ValuationReason = 'valuationReason',
  /** Хотите, чтобы с вами связался риелтор, для уточнения оценки? **/
  WantRealtor = 'wantRealtor',
  /** Хотите сами выбрать риелторов для отправки заявки? **/
  WantToChooseRealtor = 'wantToChooseRealtor',
  /** Вот что нашлось по вашему адресу **/
  WhatIsFoundForAddress = 'whatIsFoundForAddress',
  /** Куда выходят окна? **/
  WindowsView = 'windowsView',
  /** Продаете вместе с техникой и мебелью? **/
  WithAppliancesOrFurniture = 'withAppliancesOrFurniture',
  /** Год постройки дома **/
  YearRelease = 'yearRelease',
}
export enum ECompareType {
  /** Равно **/
  Eq = 'eq',
  /** Находится в списке **/
  InList = 'inList',
}
